import { Fragment } from "react";
import { Outlet } from "react-router-dom";

const AccIndex = () => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};

export default AccIndex;
